// detailScreen picks the single top-level screen the app-detail page renders,
// from the page's current state. It exists as a pure function so the ordering
// is testable in isolation -- and the ordering is the point.
//
// `deleting` comes first on purpose: once the owner confirms a delete, the page
// sets deleting and calls navigate("/") to send them back to the app list. But
// the detail page also polls the app on an interval, and a poll that was already
// in flight when the DELETE landed resolves with a 404 and sets `missing`. If
// missing were allowed to win, the not-found card ("This app does not exist")
// would render for a frame before the redirect. Letting deleting beat every
// other signal keeps that transition silent.
export function detailScreen({ deleting, missing, view, error, app }) {
  if (deleting) return "deleting"; // redirect to the list is in flight; show nothing scary
  if (missing) return "notfound";
  if (view === null) return "unknown";
  if (error && app === null) return "error";
  if (app === null) return "loading";
  return "app";
}
